const breeder = {
    state: {
        unverifiedBreederCount: 0,
    },
    mutations: {
        setUnverifiedBreederCount(state, unverifiedBreederCount) {
            state.unverifiedBreederCount = unverifiedBreederCount;
        },
    },
    getters: {
        getUnverifiedBreederCount(state) {
            return state.unverifiedBreederCount;
        },
    },
};

export default breeder;
